
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'VND',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const formatPrice = (price) => {
  if (!price) return parseFloat(0).toLocaleString('en-IN');
  return formatter.format(price);
};

const formatPrice1 = (price, price1) => {
  let x = parseFloat(price) + parseFloat(price)
  if (!price) return parseFloat(0).toLocaleString('en-IN');
  return formatter.format(price);
};

export { formatPrice, formatPrice1 };
